var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagonalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6251 1V9.125C11.6251 9.29076 11.5593 9.44973 11.442 9.56694C11.3248 9.68415 11.1659 9.75 11.0001 9.75C10.8343 9.75 10.6754 9.68415 10.5582 9.56694C10.441 9.44973 10.3751 9.29076 10.3751 9.125V2.50859L1.44229 11.4422C1.32502 11.5595 1.16596 11.6253 1.0001 11.6253C0.834251 11.6253 0.675191 11.5595 0.557916 11.4422C0.44064 11.3249 0.374756 11.1659 0.374756 11C0.374756 10.8341 0.44064 10.6751 0.557916 10.5578L9.49151 1.625H2.8751C2.70934 1.625 2.55037 1.55915 2.43316 1.44194C2.31595 1.32473 2.2501 1.16576 2.2501 1C2.2501 0.83424 2.31595 0.675269 2.43316 0.558058C2.55037 0.440848 2.70934 0.375 2.8751 0.375H11.0001C11.1659 0.375 11.3248 0.440848 11.442 0.558058C11.5593 0.675269 11.6251 0.83424 11.6251 1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonalArrow);
export default __webpack_public_path__ + "static/media/diagonal-arrow.0222cb6b204cb5d6f1a5a6eeff1c65d1.svg";
export { ForwardRef as ReactComponent };